// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"BarIconR_thecomp__qQowE"};